import { Button, AlertModalLayout, GeneralFormError } from '@ui-components/neo.tax';
import { FC, ReactElement, useState } from 'react';

export interface ActionButtonModalProps {
  deleteDisabled?: boolean;
  openModal?: () => void;
  closeModal: () => void;
  confirmMutation: () => Promise<void>;
  title: string;
  description: string | ReactElement;
  confirmButtonText?: string;
  cancelButtonText?: string;
  isLoading: boolean;
  loadingText?: string;
}

export const ActionButtonModal: FC<ActionButtonModalProps> = ({
  cancelButtonText = 'Cancel',
  closeModal,
  confirmButtonText = 'Confirm',
  confirmMutation,
  deleteDisabled,
  description,
  isLoading = false,
  loadingText,
  title,
}) => {
  const [errorMessage, setErrorMessage] = useState<string | ReactElement>();

  const onSubmit = async (): Promise<void> => {
    try {
      setErrorMessage(undefined);
      await confirmMutation();
      closeModal();
    } catch (error) {
      setErrorMessage(
        (errorMessage) =>
          errorMessage ||
          (error instanceof Error && error.message) ||
          'An unexpected error occurred. Please try again.',
      );
    }
  };
  const onClickCancel = (): void => {
    closeModal();
    setErrorMessage(undefined);
  };
  return (
    <AlertModalLayout
      title={title}
      copy={typeof description === 'string' ? description : ''}
      trailingContent={
        <>
          <Button size="base" variant="white" rounded="regular" onClick={onClickCancel}>
            {cancelButtonText}
          </Button>
          <Button
            disabled={deleteDisabled || isLoading}
            rounded="regular"
            size="base"
            type="submit"
            variant="rsbry"
            onClick={onSubmit}
          >
            {isLoading ? loadingText : confirmButtonText}
          </Button>
        </>
      }
    >
      {typeof description !== 'string' ? description : <></>}
      <GeneralFormError error={!!errorMessage}>{errorMessage}</GeneralFormError>
    </AlertModalLayout>
  );
};
